<template>
  <div class="about-content-skeleton">
    <div class="about-content-skeleton__title">
      <SkeletonItem :border-radius="8" height="36px" :ignore-global-animation="true" />
    </div>
    <div class="about-content-skeleton__texts">
      <div v-for="idx of TEXTS_SKELETONS_NUMBER" :key="idx" class="about-content-skeleton__texts-item">
        <SkeletonItem :border-radius="8" height="24px" :ignore-global-animation="true" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SkeletonItem } from '@experience/core-skeleton-lib';

const TEXTS_SKELETONS_NUMBER = 5;
</script>

<style scoped lang="scss">
.about-content-skeleton {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  margin-top: var(--alias-space-56);
  margin-bottom: var(--alias-space-56);

  @include adaptivity.tablet {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.about-content-skeleton__title {
  width: 280px;
}

.about-content-skeleton__texts {
  display: flex;
  flex-direction: column;
  gap: var(--alias-space-16);
  width: 100%;
}

.about-content-skeleton__texts-item {
  width: 100%;
}

.about-content-skeleton__texts-item:last-child {
  width: 35%;
}
</style>
